import axios from 'axios'
import { mounted } from 'vue-slide-up-down';
const EventBus = window.EventBus;

export const SpaVehicleCard = {
  props: ['vehicle', 'templatedir', 'lang','galleryinteraction', 'comingsoon', 'count', 'imagesForModels', 'gutembergOptions', 'urlParams','modelS', 'listingImage'],
  data(){
        return {
          picture: null,
          pictureTs: this.vehicle.picture ? this.vehicle.picture.split('XXL').join('card.jpg').replace(/\?ts=.*/, '').replace("http:","https:") : this.vehicle.picture,
          pictureWebp: this.vehicle.picture ? this.getFirstPictureWebp(this.vehicle.picture) : this.vehicle.picture,
          pictureWebpTs: this.vehicle.picture ? this.vehicle.picture.split('XXL').join('card.webp').replace(/\?ts=.*/, '').replace("http:","https:") : this.vehicle.picture,
          secondPicture: this.getSecondPicture(this.vehicle.id),
          secondPictureWebp: this.getSecondPictureWebp(this.vehicle.id),
          allPictures: this.getAllPictures(this.vehicle.id),
          cashOfferTag: this.checkCashOfferTag()
        }
  },
  mounted(){
    if (this.vehicle.picture) {
      this.getFirstPicture(this.vehicle.picture, (result) => {
        this.picture = result; // Asignar el valor de manera asíncrona
      });
    } else {
      this.picture = this.templatedir; // Asignar el valor directamente si no hay asíncronía
    }
  },
  created(){
    if(this.comingsoon == true && this.vehicle.incoming == true)
      this.templatedir = this.templatedir.split('-photo').join('-photo-incoming');
    if(!this.picture)
      this.picture = this.templatedir;  
    if(!this.pictureTs)
      this.pictureTs = this.templatedir;
    if(!this.pictureWebpTs)
      this.pictureWebpTs = this.templatedir;
    if(!this.pictureWebp)
      this.pictureWebp = this.templatedir;
    if(!this.secondPicture)
      this.secondPicture = 0;
    if(!this.secondPictureWebp)
      this.secondPictureWebp = 0;
    if(!this.allPictures)
      this.allPictures =  0;
  },
  methods: {
    vehicleSlugPart(){
      var slug = this.vehicle.condition.toLowerCase().replace(/ /g, "-") + "-" +
      this.vehicle.year.toLowerCase().replace(/ /g, "-") + "-" +
      this.vehicle.make.toLowerCase().replace(/ /g, "-") + "-" +
      this.vehicle.model.toLowerCase().replace(/ /g, "-").replace('/', '') + "-" +
      this.vehicle.id;
      return slug;
    },
    trackEvent() {
      var data = this.vehicle.year + '-' + 
      this.vehicle.make + '-' + 
      this.vehicle.model + '-' + 
      this.vehicle.trim + '-' + 
      this.vehicle.stocknumber;

      var payload = {event_category: 'LBX-VDP', event_label: 'LBX-' + data};
      window.sendGAEvent('LBX-View-Click', payload);

    //  console.log('GTAG SENT LBX-View-Click' + data);
    },
    getImagesForModel(){
      if(this.imagesForModels){
        let actualUrl = window.location.pathname.split("/");
        if(actualUrl.indexOf("model") >= 0){
            var modelS = actualUrl[actualUrl.indexOf("model")+1];
            var modelSelectedSplit = modelS.split(",");
                if(this.imagesForModels[ modelSelectedSplit[modelSelectedSplit.length-1] ] !== undefined)
                    return this.imagesForModels[ modelSelectedSplit[modelSelectedSplit.length-1] ];
                else
                    return null;
        }else if(this.gutembergOptions["model"] !== "all")
            return this.imagesForModels[this.gutembergOptions["model"].toLowerCase()];
        else
            return null;
    }else
        return null;
    },
    checkUrlExists(url) {
      url = url.replace("http:", "https:");
      return axios.head(url)
        .then(response => true) // URL válida
        .catch(error => {
          if (error.response && error.response.status === 404) {
            return false; // URL no válida
          }
          return false; // Otro error
        });
    },
    toLeadboxImageUrl(src, size = '400-300') {
      if (!src) return null;

      if (src.includes('vehicleimages.leadboxhq.com')) {
        return src.replace('http:', 'https:');
      }
      const m = src.match(
        /https?:\/\/[^/]*blob\.core\.windows\.net\/([^/]+)\/vehicles\/([^/]+)\/pictures\/([a-f0-9-]+)(?:-[A-Z]+)?(?:\.\w+)?$/i
      );
      if (!m) return null;

      const dealer = m[1];
      const vehicleId = m[2];
      const imageId = m[3];

      return `https://vehicleimages.leadboxhq.com/v1/${dealer}/${vehicleId}/${imageId}-${size}.jpg`;
    },
    buildCardSrcset(url, ext = 'jpg') {
      if (!url || typeof url !== 'string') return null;

      const qIndex = url.indexOf('?');
      const path = qIndex === -1 ? url : url.slice(0, qIndex);
      const query = qIndex === -1 ? '' : url.slice(qIndex);

      // New CDN is size-parametric: swap the trailing -{w}(-{h}) suffix per
      // width so high-DPR screens can pick a larger rendition.
      if (path.includes('vehicleimages.leadboxhq.com')) {
        // Try the -{w}-{h} crop suffix first: the greedy (.+) would otherwise
        // swallow the width and misread the height as the width.
        const crop = path.match(/^(.+)-(\d+)-(\d+)\.(jpg|jpeg|png|webp)$/i);
        const m = crop || path.match(/^(.+)-(\d+)\.(jpg|jpeg|png|webp)$/i);
        if (m) {
          const base = m[1];
          const w0 = parseInt(m[2], 10);
          const h0 = crop ? parseInt(crop[3], 10) : null;
          return [400, 800, 1200].map((w) => {
            const size = h0 ? `${w}-${Math.round((h0 / w0) * w)}` : `${w}`;
            return `${base}-${size}.${ext}${query} ${w}w`;
          }).join(', ');
        }
      }

      // Legacy blob CDN / other sources: keep today's single candidate — the
      // named renditions (-gallery/-XXL) are not guaranteed to exist per dealer.
      return (ext === 'webp' ? path.replace('.jpg', '.webp') : path) + query;
    },
    buildCardSrcsetWebp(url) {
      return this.buildCardSrcset(url, 'webp');
    },
    cardSizes(width = 350) {
      return `(max-width: 640px) 100vw, ${width}px`;
    },
    getFirstPicture(vehiclePicture, callback) {
      const leadboxUrl = this.toLeadboxImageUrl(vehiclePicture, '400');
      if (leadboxUrl) {
        callback(leadboxUrl);
        return;
      }

      if (vehiclePicture && EventBus.checkValidCDN(vehiclePicture)) {
        this.checkUrlExists(vehiclePicture).then(status => {
          let result;
          if (status) {
            if (vehiclePicture.includes('XXL')) {
              result = vehiclePicture.split('XXL').join('card.jpg').replace("http:", "https:");
            } else if (vehiclePicture.includes('.png') || vehiclePicture.includes('invassets')) {
              result = vehiclePicture.replace("http:", "https:");
            } else if( vehiclePicture.includes('forddirect/cache/')){
              result = vehiclePicture.replace("http:", "https:").replace('-XXL','');
            } else {
              result = vehiclePicture.replace("http:", "https:") + "-card.jpg";
            }
          } else {
            console.warn('** --> URL not found: ', vehiclePicture);
            result = vehiclePicture.split('-XXL').join('').replace("http:", "https:");
          }
          callback(result); // Devolver el resultado a través del callback
        }).catch(error => {
          console.error("Error checking URL:", error);
          callback(vehiclePicture.replace("http:", "https:")); // En caso de error, devolver la URL modificada
        });
      } else {
        callback(vehiclePicture.replace("http:", "https:").replace('.jpg-XXL', '.jpg')); // Si no hay vehiclePicture o no es válido
      }
    },
    getFirstPictureWebp(vehiclePicture){
      if(vehiclePicture && EventBus.checkValidCDN(vehiclePicture)){
        if(vehiclePicture.includes('XXL'))
          return vehiclePicture.split('XXL').join('card.webp').replace("http:","https:")
        else if(vehiclePicture.includes('.png') || vehiclePicture.includes('invassets'))
          return vehiclePicture.replace("http:","https:");
        else
          return vehiclePicture.replace("http:","https:")+"-card.webp";
      }
      else{
        return vehiclePicture.replace("http:","https:");
      }
    },
    getSecondPicture(vehicleId) {
        if(vehicleId && vehicleId != undefined && (this.galleryinteraction != '' && this.galleryinteraction == 'swap-photo') || window.location.origin.includes("yorkdalelincoln")){
        var finalUrl = "";

        var urlDetail = window.location.origin+"/wp-content/uploads/data/"+vehicleId+".json?v=" + EventBus.getJSONTimestamp(5,'Detail');
          axios.get(urlDetail)
          .then(({ data }) => {
            if(data.pictures && data.pictures.length > 0){
              finalUrl = data.pictures[1];

              if(finalUrl && EventBus.checkValidCDN(finalUrl)){
                if(finalUrl.includes('XXL'))
                  this.secondPicture = finalUrl.split('XXL').join('card.jpg').replace("http:","https:");
                else if(finalUrl.includes('.png') || finalUrl.includes('invassets') )
                  this.secondPicture =  finalUrl.replace("http:","https:");
                else
                  this.secondPicture = finalUrl.replace("http:","https:")+"-card.jpg";
              }
              else{
                this.secondPicture = finalUrl.replace("http:","https:");
              }
            } else {
              finalUrl = this.templatedir;
              this.secondPicture = finalUrl;
            }
        });
    }
    return null;
    },
    getSecondPictureWebp(vehicleId) {
      if(vehicleId && vehicleId != undefined && (this.galleryinteraction != '' && this.galleryinteraction == 'swap-photo')){
        var finalUrl = "";

        var urlDetail = window.location.origin+"/wp-content/uploads/data/"+vehicleId+".json?v=" + EventBus.getJSONTimestamp(5,'Detail');
          axios.get(urlDetail)
          .then(({ data }) => {
            if(data.pictures && data.pictures.length > 0){
              finalUrl = data.pictures[1];

              if(finalUrl && EventBus.checkValidCDN(finalUrl)){
                if(finalUrl.includes('XXL'))
                  this.secondPictureWebp = finalUrl.split('XXL').join('card.jpg').replace("http:","https:");
                else if(finalUrl.includes('.png') || finalUrl.includes('invassets') )
                  this.secondPictureWebp =  finalUrl.replace("http:","https:");
                else
                  this.secondPictureWebp = finalUrl.replace("http:","https:")+"-card.webp";
              }
              else{
                this.secondPictureWebp = finalUrl.replace("http:","https:");
              }
            }
        });
    }
    return null;
    },
    getAllPictures(vehicleId) {
      if(vehicleId && vehicleId != undefined  && (this.galleryinteraction != '' && this.galleryinteraction == 'mini-gallery')  ){
        var urlDetail = window.location.origin+"/wp-content/uploads/data/"+vehicleId+".json?v=" + EventBus.getJSONTimestamp(5,'Detail');

          axios.get(urlDetail)
          .then(({ data }) => {
            if(data.pictures && data.pictures.length > 0){
              for(var i= 0; i < data.pictures.length; i++){
                if(data.pictures[i] && EventBus.checkValidCDN(data.pictures[i])){
                  if(data.pictures[i].includes('XXL'))
                    data.pictures[i] = data.pictures[i].split('XXL').join('card.jpg').replace("http:","https:");
                  else if(data.pictures[i].includes('.png') || data.pictures[i].includes('invassets') )
                    data.pictures[i] =  data.pictures[i].replace("http:","https:");
                  else
                    data.pictures[i] = data.pictures[i].replace("http:","https:")+"-card.jpg";
                }
                else{
                  data.pictures[i] = data.pictures[i].replace("http:","https:");
                }
              }

              setTimeout(() => {
                      if(!data.trim)
                        var dtrim = "";
                      else
                        var dtrim = data.trim.split(' ').join('-');

                      jQuery(".slick-gallery-"+vehicleId).not(".slick-initialized").slick({dots:!0,
                        nextArrow: "<button data-vehicle='"+data.condition+'-'+data.year+'-'+data.make+'-'+data.model.split(' ').join('-')+'-'+dtrim+'-'+data.stocknumber+"' class='slick-next slick-arrow' aria-label='Next' type='button'>Next</button>",
                        infinite:!0,speed:500,slidesToShow:1,slidesToScroll:1,responsive:[{breakpoint:1279,settings:{slidesToShow:1,slidesToScroll:1,infinite:!0,dots:!0}},{breakpoint:600,settings:{slidesToShow:1,slidesToScroll:1,infinite:!0,dots:!0}}]});
              },100);
              var allp = data.pictures.slice(0,11);
              this.allPictures = allp;
            } else
                this.allPictures = [this.templatedir];
            
            setTimeout(() => {
                var lazyImages = [].slice.call(document.querySelectorAll(".vehicle-card .main-img"));
                    if (!('IntersectionObserver' in window) ||
                    !('IntersectionObserverEntry' in window) ||
                    !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
                        lazyImages.forEach(img => {
                            img.src = img.dataset.src;
                        });
                    }else{
                        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                            entries.forEach(function(entry) {
                                if (entry.isIntersecting) {
                                    let lazyImage = entry.target;
                                    lazyImage.src = lazyImage.dataset.src;
                                    lazyImageObserver.unobserve(lazyImage);
                                }
                            });
                        });
                    
                        lazyImages.forEach(function(lazyImage) {
                        lazyImageObserver.observe(lazyImage);
                        });
                    }
             },100);

          })
      }
    },
    trackEventForm(formType) {
      var payload = {event_category: 'LBX-Form', event_label: 'LBX-Form-' + formType};
      window.sendGAEvent('LBX-View', payload);

      console.log('GTAG SENT LBX-View-Form-Click');
    },
    imgLoadOnError(id) {
        if(id){
            for (let i = 0; i < this.$refs[id+"vc-main-img"].length; i++) {
                this.$refs[id+"vc-main-img"][i].src = this.templatedir;
            }
        }
        this.picture = this.templatedir;
    },
    FloorPlanLoadOnError(id) {
      if(this.$refs[id][0] && this.$refs[id][0].parentNode.parentNode) {
        this.$refs[id][0].parentNode.parentNode.remove();
      }
    },
    imgMiniGalleryLoadOnError(index, prefixLabel) {
      let prefix = (prefixLabel) ? prefixLabel : "mini_img_";
      this.$refs[prefix + index][0].src = this.templatedir;

      if(this.$refs[prefix + index] && this.$refs[prefix + index][0] && this.$refs[prefix + index][0].parentNode && this.$refs[prefix + index][0].parentNode.children){
        for (let i = 0; i < this.$refs[prefix + index][0].parentNode.children.length; i++) {
          this.$refs[prefix + index][0].parentNode.children[i].srcset = this.templatedir;
          
          if(this.$refs[prefix + index][0].parentNode.children[i].src){
            this.$refs[prefix + index][0].parentNode.children[i].src = this.templatedir;
          }
          if(this.$refs[prefix + index][0].parentNode.children[i].getAttribute('data-src')){
            this.$refs[prefix + index][0].parentNode.children[i].setAttribute("data-src", this.templatedir);
          }
        }
      }
    },
    imgLoadOnErrorSecondPicture() {
      this.secondPicture = this.templatedir;
    },
    goToCompare(id) {
      EventBus.$emit('goToCompare', id, this.lang);
    },
    isMoreThan(value1, value2) {
      return value1 > value2
    },
    isMoreOrEqualThan(value1, value2) {
      return value1 >= value2
    },
    isLessOrEqualThan(value1, value2) {
      return value1 <= value2
    },
    isLessThan(value1, value2) {
      return value1 < value2
    },
    isTrue(value) {
      return value;
    },
    sumValue(value1, value2) {
      return value1 + value2
    },
    subtractValue(value1, value2) {
      return value1 - value2
    },
    checkCashOfferTag(){
      if (!this.vehicle.tags || !this.vehicle.tags.trim()) {
        return '';
      }
      
      let tagArray = this.vehicle.tags.split('-');
      if(tagArray[0].trim() == 'Cash Offer') {
        return 'Cash Offer'
      } else {
        return '';
      }
    },
  },
  computed: {
    pictureSrcset() {
      return this.buildCardSrcset(this.picture);
    },
    pictureSrcsetWebp() {
      return this.buildCardSrcsetWebp(this.picture);
    },
    pictureSizes() {
      return this.cardSizes(350);
    },
    secondPictureSrcset() {
      return this.buildCardSrcset(this.secondPicture);
    },
    secondPictureSrcsetWebp() {
      return this.buildCardSrcsetWebp(this.secondPicture);
    },
    vehicleTitle(){
      if(this.lang == 'fr-CA')
        return (this.vehicle.condition ? `${this.vehicle.condition} ` : "") +
          (this.vehicle.make ? `${this.vehicle.make} ` : "") +
          (this.vehicle.model ? `${this.vehicle.model} ` : "") +
          (this.vehicle.year ? `${this.vehicle.year} ` : "") +
          (this.vehicle.trim ? `${this.vehicle.trim} ` : "") +
          (this.vehicle.stocknumber ? `${this.vehicle.stocknumber}` : "");
      else
        return (this.vehicle.condition ? `${this.vehicle.condition} ` : "") +
          (this.vehicle.year ? `${this.vehicle.year} ` : "") +
          (this.vehicle.make ? `${this.vehicle.make} ` : "") +
          (this.vehicle.model ? `${this.vehicle.model} ` : "") +
          (this.vehicle.trim ? `${this.vehicle.trim} ` : "") +
          (this.vehicle.stocknumber ? `${this.vehicle.stocknumber}` : "");
    },
    viewSlug(){
      let slug = "/view/";
      if(this.lang == 'fr-CA')
        slug = "/vue/";

      return slug + this.vehicleSlugPart() + "/"
    },
    discount(){
      let result = this.vehicle.saleprice - this.vehicle.price;
      return ((result > 0 ) ? result : 0);
    },
    showMSRP(){
      let result = (this.vehicle.saleprice && this.vehicle.saleprice > 0 && this.vehicle.saleprice > this.vehicle.price);
      return result;
    },
    finalPrice(){
      if (!this.vehicle.tags || !this.vehicle.tags.trim()) {
        return this.vehicle.price;
      }

      let tagArray = this.vehicle.tags.split('-');
      if(tagArray[0].trim() == 'Cash Offer') {
        return (this.vehicle.price) - (parseFloat(tagArray[1]));
      } else {
        return this.vehicle.price;
      }     
    }
  },
  filters: {
    moneyFormat:(price, lang)=>{
      var formatter = new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 0,
      });
      return formatter.format(Math.floor(price));
    },
    mileageFormat:(mileage,lang)=>{

      const formatter = new Intl.NumberFormat(lang, {
        style: 'unit',
        unit: 'kilometer'
      });
     
     return formatter.format(Math.floor(mileage));
    },
    replaceLiter:(string)=>{
      if(string)
        return string.replace("Liter","L").replace("liter","L").replace("litre","L").replace("Litre","L");
      else
        return "-";

    },
    stringReplace:(value, search, rep)=>{
      let replacement = '';
      if (typeof rep !== 'undefined' && !rep) { 
        replacement = rep;
      } 

      if (typeof value === 'undefined' || value === null) 
        return "";
      else
        return value.replace(search,replacement);
    }
  }
}